import styles from '../Prompt.module.less'
import MarkdownRenderer from 'Components/common/MarkdownRenderer/MarkdownRenderer'

type PromptMarkdownContentPropsType = {
    content: string
    id: string
    allowRawHtml?: boolean
}

export const PromptMarkdownContent = (props: PromptMarkdownContentPropsType) => {
    return (
        <div className={styles['text-content']} id={props.id} data-testid="markdown-content">
            <MarkdownRenderer
                children={props.content}
                escapeBackslashses={true}
                allowRawHtml={props.allowRawHtml}
            />
        </div>
    )
}
